import { createClient } from '@supabase/supabase-js';
import { useMemo } from 'react';
import { useSession } from '@clerk/clerk-react';
import { supabaseKey, supabaseUrl } from '../services/supabase/supabaseClient.js';

const clerkSupabaseClients = new Map();

export const createClerkSupabaseClient = (session) => {
  const sessionKey = session?.id || '__default__';

  if (!clerkSupabaseClients.has(sessionKey)) {
    clerkSupabaseClients.set(
      sessionKey,
      createClient(supabaseUrl, supabaseKey, {
        accessToken: async () => {
          const token = await session?.getToken();
          return token ?? null;
        },
        auth: {
          persistSession: false,
          autoRefreshToken: false,
          detectSessionInUrl: false,
          storageKey: `tadmin-clerk-supabase-${sessionKey}`,
        },
        global: {
          headers: { apikey: supabaseKey },
          fetch: async (url, options = {}) => {
            const token = session ? await session.getToken() : null;
            const headers = new Headers(options?.headers);
            headers.set('apikey', supabaseKey);
            if (token) headers.set('Authorization', `Bearer ${token}`);
            return fetch(url, { ...options, headers });
          },
        },
      })
    );
  }

  return clerkSupabaseClients.get(sessionKey);
};

export const useSupabaseClient = () => {
  const { session } = useSession();
  return useMemo(() => createClerkSupabaseClient(session), [session]);
};
